<template>
  <div class="banned">
    <div class="banned_contentbox">
      <div class="banned_content_title">社区账号已被封禁</div>
      <div class="banned_content_con">
        <p>亲爱的玩家，由于您多次發布违规内容，导致账号被封禁。</p>
        <p>违规原因：{{ $store.state.bannedText }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'banned'
};
</script>
<style scoped>
</style>